import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
} from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

import { IPurchaseOrderItemBulkUpdateDetails } from '../../interfaces';

@Component({
  selector: 'lum-purchase-order-item-form',
  templateUrl: './purchase-order-item-form.component.html',
  styleUrls: ['./purchase-order-item-form.component.scss'],
})
export class PurchaseOrderItemFormComponent implements OnInit {
  form :UntypedFormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data :any,
    private dialogRef :MatDialogRef<PurchaseOrderItemFormComponent>,
    private fb :UntypedFormBuilder,
  ) {}

  ngOnInit() :void {
    this.initForm();
  }

  onSubmit() :void {
    const result :IPurchaseOrderItemBulkUpdateDetails = {};
    if (this.form.controls['purchasePrice'].dirty) {
      result.purchasePrice = this.form.value.purchasePrice;
    }
    if (this.form.controls['purchaseQty'].dirty) {
      result.purchaseQty = this.form.value.purchaseQty;
    }
    if (this.form.controls['addToReceivingQty'].dirty) {
      result.addToReceivingQty = this.form.value.addToReceivingQty;
    }
    this.dialogRef.close(result);
  }

  onClose() :void {
    this.dialogRef.close();
  }

  private initForm() :void {
    this.form = this.fb.group({
      purchasePrice: [null, [this.validatePurchasePrice.bind(this)]],
      purchaseQty: [null, [this.validatePurchaseQty.bind(this)]],
      addToReceivingQty: [null, [this.validateAddToReceivingQty.bind(this)]],
    });
  }

  private validatePurchasePrice(control :AbstractControl) :ValidationErrors | null {
    const purchasePrice = control.value;

    if (!control.dirty) {
      return null;
    }
    if (purchasePrice === null || typeof purchasePrice === 'string') {
      return { purchasePrice: 'Invalid value for Purchase Price' };
    }
    if (typeof purchasePrice !== 'number') {
      return { purchasePrice: 'Purchase Price must be a number' };
    }
    if (purchasePrice < 0) {
      return {
        purchasePrice: 'Purchase Price cannot be less than 0',
      };
    }

    return null;
  }

  private validatePurchaseQty(control :AbstractControl) :ValidationErrors | null {
    const purchaseQty = control.value;

    if (!control.dirty) {
      return null;
    }
    if (purchaseQty === null || typeof purchaseQty === 'string') {
      return { purchaseQty: 'Invalid value for Purchase Quantity' };
    }
    if (typeof purchaseQty !== 'number') {
      return { purchaseQty: 'Purchase Quantity must be a number' };
    }
    if (purchaseQty < 1) {
      return {
        purchaseQty: 'Purchase Quantity cannot be less than 1',
      };
    }

    return null;
  }

  private validateAddToReceivingQty(
    control :AbstractControl,
  ) :ValidationErrors | null {
    const addToReceivingQty = control.value;

    if (!control.dirty) {
      return null;
    }
    if (addToReceivingQty === null || typeof addToReceivingQty === 'string') {
      return { addToReceivingQty: 'Invalid value for Add to Receiving Quantity' };
    }
    if (typeof addToReceivingQty !== 'number') {
      return { addToReceivingQty: 'Add to Receiving Quantity must be a number' };
    }
    if (addToReceivingQty < 0) {
      return {
        addToReceivingQty: 'Add to Receiving Quantity cannot be less than 0',
      };
    }

    return null;
  }
}
